
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.528 7.337H5.082l3.253-3.254a.672.672 0 000-.946.664.664 0 00-.94 0L3.002 7.53c-.26.26-.26.68 0 .94l4.393 4.393a.664.664 0 10.94-.94L5.082 8.67h7.446c.367 0 .667-.3.667-.667 0-.366-.3-.666-.667-.666z","fill":"#9D4B72"}})])
          )
        }
      }
    